import {all} from 'redux-saga/effects';

export function* rootSaga() {
    // TODO: Set RootsSagas
    yield all([]);
}